export default __webpack_public_path__ + "static/media/Union 1.cdc072e7.svg";